import React from 'react';
import { ASSETS } from '../constants/assets';
import { motion } from 'framer-motion';
export function ElderFloatingButton() {
  return <motion.div initial={{
    x: 100
  }} animate={{
    x: 0
  }} className="fixed right-0 top-1/2 -translate-y-1/2 z-40" data-id="element-27">
      <button className="bg-white shadow-[-4px_0_12px_rgba(0,0,0,0.1)] rounded-l-2xl p-2 flex flex-col items-center gap-1 border-y border-l border-gray-100 active:scale-95 transition-transform" data-id="element-28">
        <img src={ASSETS.iconElder} alt="Elder" className="size-8 object-contain" data-id="element-29" />
        <span className="text-[20rpx] font-bold text-[#66CADA] [writing-mode:vertical-rl]" data-id="element-30">
          长者版
        </span>
      </button>
    </motion.div>;
}